module.exports = __webpack_public_path__ + "static/media/treeremoval.03941e68.jpg";